import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";

import {
  getPostings,
  updateAbroadPostingInfo,
  updateDeputationPostingInfo,
  updatePostingRecordPostingInfo,
  updateForeignTravelPostingInfo,
  deleteAbroadPostingInfo,
  deleteDeputationPostingInfo,
  deletePostingRecordPostingInfo,
  deleteForeignTravelPostingInfo,
} from "@api/postings";

import {
  PostingActions,
  getPostingsFailed,
  getPostingsSuccess,
  updateAbroadPostingsInfoFailed,
  updateAbroadPostingsInfoSuccess,
  updateDeputationPostingsInfoFailed,
  updateDeputationPostingsInfoSuccess,
  updatePostingRecordPostingsInfoFailed,
  updatePostingRecordPostingsInfoSuccess,
  updateForeignTravelPostingsInfoFailed,
  updateForeignTravelPostingsInfoSuccess,
  deleteAbroadPostingInfoFailed,
  deleteAbroadPostingInfoSuccess,
  deleteDeputationPostingInfoFailed,
  deleteDeputationPostingInfoSuccess,
  deletePostingRecordPostingInfoFailed,
  deletePostingRecordPostingInfoSuccess,
  deleteForeignTravelPostingInfoFailed,
  deleteForeignTravelPostingInfoSuccess,
} from "@actions/HRM/employee/postings-action";
import {
  GET_POSTINGS,
  UPDATE_ABROAD_POSTING_INFO,
  UPDATE_DEPUTATION_POSTING_INFO,
  UPDATE_POSTING_RECORD_POSTING_INFO,
  UPDATE_FOREIGN_TRAVEL_POSTING_INFO,
  DELETE_ABROAD_POSTING_INFO,
  DELETE_DEPUTATION_POSTING_INFO,
  DELETE_POSTING_RECORD_POSTING_INFO,
  DELETE_FOREIGN_TRAVEL_POSTING_INFO,
} from "@actions/HRM/employee/types";

import { isRequestCancelled } from "@helpers/routing";
import { StoreType } from "@reducers/types";

export const postingsMiddleware: Middleware<
  Record<string, unknown>,
  StoreType
> = ({ dispatch }: MiddlewareAPI) => {
  return (next: Dispatch<AnyAction>) => {
    return async (action: PostingActions) => {
      const nextAction = next(action);
      switch (action.type) {
        case GET_POSTINGS.GET_POSTINGS_REQUEST: {
          try {
            const { payload } = action as any;

            const { data } = await getPostings(payload);

            dispatch(getPostingsSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(getPostingsFailed());
            }
          }
          break;
        }

        case UPDATE_ABROAD_POSTING_INFO.UPDATE_ABROAD_POSTING_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updateAbroadPostingInfo(payload);

            dispatch(updateAbroadPostingsInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateAbroadPostingsInfoFailed());
            }
          }

          break;
        }

        case UPDATE_DEPUTATION_POSTING_INFO.UPDATE_DEPUTATION_POSTING_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updateDeputationPostingInfo(payload);

            dispatch(updateDeputationPostingsInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateDeputationPostingsInfoFailed());
            }
          }

          break;
        }

        case UPDATE_POSTING_RECORD_POSTING_INFO.UPDATE_POSTING_RECORD_POSTING_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updatePostingRecordPostingInfo(payload);

            dispatch(updatePostingRecordPostingsInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updatePostingRecordPostingsInfoFailed());
            }
          }

          break;
        }

        case UPDATE_FOREIGN_TRAVEL_POSTING_INFO.UPDATE_FOREIGN_TRAVEL_POSTING_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await updateForeignTravelPostingInfo(payload);

            dispatch(updateForeignTravelPostingsInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(updateForeignTravelPostingsInfoFailed());
            }
          }

          break;
        }

        case DELETE_ABROAD_POSTING_INFO.DELETE_ABROAD_POSTING_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deleteAbroadPostingInfo(payload);

            dispatch(deleteAbroadPostingInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteAbroadPostingInfoFailed());
            }
          }

          break;
        }

        case DELETE_DEPUTATION_POSTING_INFO.DELETE_DEPUTATION_POSTING_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deleteDeputationPostingInfo(payload);

            dispatch(deleteDeputationPostingInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteDeputationPostingInfoFailed());
            }
          }

          break;
        }

        case DELETE_POSTING_RECORD_POSTING_INFO.DELETE_POSTING_RECORD_POSTING_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deletePostingRecordPostingInfo(payload);

            dispatch(deletePostingRecordPostingInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deletePostingRecordPostingInfoFailed());
            }
          }

          break;
        }

        case DELETE_FOREIGN_TRAVEL_POSTING_INFO.DELETE_FOREIGN_TRAVEL_POSTING_INFO_REQUEST: {
          try {
            const { payload } = action as any;
            const { data } = await deleteForeignTravelPostingInfo(payload);

            dispatch(deleteForeignTravelPostingInfoSuccess(data));
          } catch (error) {
            if (!isRequestCancelled(error)) {
              dispatch(deleteForeignTravelPostingInfoFailed());
            }
          }

          break;
        }
      }
      return nextAction;
    };
  };
};
